export default __webpack_public_path__ + "static/media/circle-01.d3ba46ce.png";